<h2 mat-dialog-title>Modificar Hora Programada</h2>
<div mat-dialog-content>
  <div class="time-picker-inline">
    <mat-form-field class="time-field">
      <mat-label>Horas</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="selectedHour"
        [min]="0"
        [max]="23"
        placeholder="HH"
      />
    </mat-form-field>
    <span class="time-separator">:</span>
    <mat-form-field class="time-field">
      <mat-label>Minutos</mat-label>
      <input
        matInput
        type="number"
        [(ngModel)]="selectedMinute"
        [min]="0"
        [max]="59"
        placeholder="MM"
      />
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button color="primary" (click)="save()">Guardar</button>
</div>